import "twin.macro";

import { ArrowUpDown } from "lucide-react";

import { SortDirection } from "@/utils/searchSort";

export default function SortDirectionButton({
  direction,
  onToggle,
  ariaLabelAsc,
  ariaLabelDesc,
  className,
}: {
  direction: SortDirection;
  onToggle: () => void;
  ariaLabelAsc: string;
  ariaLabelDesc: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={className}
      tw="shrink-0 inline-flex items-center justify-center h-10 w-10 rounded-xl border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors focus:(ring-2 ring-primary-200 border-primary-300)"
      aria-label={direction === "asc" ? ariaLabelAsc : ariaLabelDesc}
    >
      <ArrowUpDown tw="w-4 h-4" />
    </button>
  );
}
